import React from "react";
import { getContentPageProps } from "../logic/contentLogic";

const Article = React.lazy(() => import("../components/Article"));

export const renderArticleContent = (content, props = {}) => {
  const Helmet = props.helmet;

  return (
    <>
      <Helmet />
      <Article key={content.id} {...getContentPageProps(content)} />
    </>
  );
};
